import Fetch from '../Fetch';

export default {
  queryPingInfo: (params) => {
    return Fetch.get(`/api/v1/ping_test`, { params, loading: false });
  },

  queryTraceInfo: (params) => {
    return Fetch.get(`/api/v1/trace_test`, { params, loading: false });
  },

  queryDnsLookupInfo: (params) => {
    return Fetch.get(`/api/v1/dns_lookup`, { params, loading: false });
  }
};
